import { payAgainApi } from '@/api/order'
import {
  wechatPay,
  wxMpPay
} from '@/utils/payment/wechatPay'
import store from '@/store'
import { judgeUserAgent } from '@/utils/judgeUserAgent'



// 获取用户openId
const getOpenId = () => {
  const openId = store.getters.userInfo.openId
  if (openId) {
    return openId
  } else {
    return ''
  }
}


const getWxPayType = () => {
// const wxPayTypeMap = {
//   JSSDK: 1,
//   WeixinJSBridge: 2,
//   mp: 3,
//   h5: 4
//   }
  
  // 微信小程序支付
  if (judgeUserAgent('WXMP')) {
    return 3
  }

  // 微信公众号支付
  if (judgeUserAgent('WXWEB')) {
    return 2
  }

  // 非微信浏览器支付
  if (judgeUserAgent('WXH5')) {
    return 4
    
  }
}

/**
 *
 * @param {*} param0
 * @param {object} data
 * @param {string} data.pay_id - 订单编号
 * @param {string} data.open_id
 * @param {string} data.payType  1:积分支付 2:余额支付 3:微信支付 20:混合支付 21:福利卡支付
 * @param {string} data.order_sn - 订单编号
 */

async function paymentAgain (data) {
  console.log(data, 'payment again data');
  
  const wxPayType = getWxPayType()
  // 判断是否在小程序环境支付
  if (wxPayType === 3 && data.pay_type === 3) {
    // datas.openid = getOpenId()
    // datas.wx_pay_type = getWxPayType()
    wxMpPay({
      pay_id: data.pay_id,
      order_sn: data.order_sn
    })
    return Promise.reject('支付中')
  }
  
  const datas = {
    pay_id: data.pay_id,
    openid: data.pay_type === 3 ? getOpenId() : undefined,
    wx_pay_type: data.pay_type === 3 ? wxPayType : undefined
  }

  const result = await payAgainApi(datas).catch(error => {
    throw error
  })
  
  if (!result.data.data.status) {
    return result.data.data
  }
  
  // 微信支付
  if (data.pay_type === 3) {
    const payData = result.data.data.payment.pay_data
    const weiChatPay = await wechatPay({
      payData: payData,
      order_sn: data.order_sn,
      pay_id: data.pay_id
    })

    // console.log(weiChatPay, 'weiChatPay');
    
    if (weiChatPay.status) {
      return Promise.resolve({
        status: true,
        msg: '支付成功'
      }) 
    } else {
       return Promise.resolve({
         status: false,
         message: weiChatPay.msg
       }) 
      // 微信支付失败
      // return Promise.reject({
      //   status: false,
      //   msg: weiChatPay.meg
      // })
    }
  }
  
  return result.data.data
}

/**
 *
 * @param {*} param0
 * @param {object} data
 * @param {string} data.pay_id - 订单编号
 * @param {string} data.open_id
 * @param {string} data.payType  1:积分支付 2:余额支付 3:微信支付 20:混合支付 21:福利卡支付
 * @param {string} data.order_sn - 订单编号
 */

async function payAgain ({ dispatch }, data) {
  const results = []
  // 支付排序 如果data.payType == 3 则最后支付
  const sortData = data.sort((a, b) => {
   return a.payType === 3 ? 1 : -1
  })

   try {
     for (const payInfo of sortData) {
       const result = await paymentAgain({
         pay_id: payInfo.pay_id,
        //  open_id: openId,
         pay_type: payInfo.payType,
         order_sn: data.order_sn
       })

       results.push(result)
       
       if (!result.status) {
         return Promise.resolve(result)
       }
     }

     return Promise.resolve({
       status: true,
       msg: '支付成功',
     })

   } catch (error) {
     return Promise.resolve({
       status: false,
       msg: error
     })
   }
}



export default payAgain